import { Arg, Metadata } from '../../../../../utils/spds/metadata';
import FlexRow from '../../../layout/flex/row.gjs';
import Super from '../../../core/base.gjs';

const METADATA = Metadata.define({
  description: 'Header text for the alert banner message',
  meta: {
    header: Arg.string({ description: 'Header text content' }),
  },
  name: 'Alert Banner Message Header',
});

export default class SpdsFeedbackAlertBannerMessageHeader extends Super {
  static metadata = this.setMetadata(METADATA, import.meta.url);
  baseClass = 'spds-feedback-alert-banner-message-header';

  <template>
    <FlexRow
      class={{this.classes}}
      data-test-spds-feedback-alert-banner-message-header
      {{this.validateArguments}}
      ...attributes
    >
      {{@header}}
    </FlexRow>
  </template>
}

export const ALERT_BANNER_MESSAGE_HEADER_METADATA = SpdsFeedbackAlertBannerMessageHeader.metadata;
